import DataStore from '../../core/stores/data-store'
import FormStore from '../../core/stores/form-store'

export interface PolicyItem {
  id: string,
  title : string,
   body: string
}
export interface NewPolicyItem {
  title : string,
  body: string
}



export class PoliciesStore extends DataStore<PolicyItem> {
  private publicUrl: string
  constructor(baseUrl: string) {
    super(`${baseUrl}/api/v1/admin/policy`, [])
    this.publicUrl = baseUrl
  }

  public async update(id: string, item: PolicyItem) {
    return this.save(id, item)
  }
}

export class PolicyItemStore extends FormStore< PolicyItem, NewPolicyItem> {
  private publicUrl: string
  constructor(baseUrl: string) {
    super(`${baseUrl}/api/v1/admin/policy`)
    this.publicUrl = baseUrl
  }
}